// extracted by mini-css-extract-plugin
export var cardWrapper = "_6d-0";